import type { Peer } from "@circle-react/types/Live/Peer";
import { useHMSLocalParticipant } from "../hms/useHMSLocalParticipant";
import { useLivekitLocalPeer } from "../livekit/useLivekitLocalPeer";
import { useProviderHook } from "./useProviderHook";

export const useProviderLocalParticipant = (): Peer | undefined =>
  useProviderHook({
    hms: useHMSLocalParticipant,
    livekit: useLivekitLocalPeer,
  })();
